function getRequestBody(data, startDate, endDate) {
  return {
    name: data.Nome,
    endereco:{
      logradouro: data.Logradouro,
      numero: data.Numero,
      bairro: data.Bairro,
    },
  
    horario:{
        inicio: startDate,
        final: endDate
    },
  
    contatos:{
        tel:data.Telefone,
        whatsapp: data.Whatsapp
    }
  }
}

export default getRequestBody


